import React from 'react';
import { Switch, Route } from 'react-router';
import { TimelineOrganization } from './organization/TimelineOrganization';
import { TimelineLocation } from './locations/TimelineLocation';
import { AppRoutes } from '../../routes';

export const Timeline: React.FC = () => (
    <>
        <Switch>
            <Route path={AppRoutes.TimelineLocation} component={TimelineLocation} />
            <Route path={AppRoutes.TimelineOrganization} component={TimelineOrganization} />
        </Switch>
    </>
);
